import script from "./CardBenefit.vue?vue&type=script&setup=true&lang=js"
export * from "./CardBenefit.vue?vue&type=script&setup=true&lang=js"

import "./CardBenefit.vue?vue&type=style&index=0&id=7f84cfa6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f84cfa6"]])

export default __exports__